// skills/admin/adminData.js
// Admin panel configuration and default state

export const DEFAULT_ADMIN_STATE = {
    global: {
        speedMultiplier: 1.0,    // Game tick speed multiplier
        xpMultiplier: 1.0,       // Global XP rate multiplier
    },
    skillOverrides: {},          // Per-skill: { mining: { speedMultiplier, xpMultiplier } }
    nodeXpOverrides: {},         // "skillId:nodeId": xpValue
    toolSpeedOverrides: {},      // "toolId": speedMultiplier
    corruptionProcChance: null,  // Override corruption proc chance (null = use default)
    isActive: false,             // Whether any overrides are currently active
};

export const CORRUPTION_CHANCE_PRESETS = [
    { label: 'Default', value: null },
    { label: '1%', value: 0.01 },
    { label: '5%', value: 0.05 },
    { label: '10%', value: 0.10 },
    { label: '25%', value: 0.25 },
    { label: '50%', value: 0.50 },
    { label: '100%', value: 1.0 },
];

export const SPEED_PRESETS = [1, 2, 5, 10, 20, 50];
export const XP_PRESETS = [1, 2, 5, 10, 50, 100];

export const MIN_LEVEL = 1;
export const MAX_LEVEL = 99;
export const MAX_VIRTUAL_LEVEL = 120;

export const TIME_SKIP_PRESETS = [1, 5, 15, 30, 60]; // minutes
export const ACTION_COMPLETE_PRESETS = [1, 5, 10, 50, 100];

// Offline simulation presets (minutes)
export const OFFLINE_PRESETS = [
    { label: '5m', minutes: 5 },
    { label: '30m', minutes: 30 },
    { label: '1h', minutes: 60 },
    { label: '6h', minutes: 360 },
    { label: '24h', minutes: 1440 },
];
